import { render, staticRenderFns } from "./Biodiversidad.vue?vue&type=template&id=6473a067&"
import script from "./Biodiversidad.vue?vue&type=script&lang=js&"
export * from "./Biodiversidad.vue?vue&type=script&lang=js&"
import style0 from "./Biodiversidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports